class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filterForm = this.querySelector('form');
    if (this.filterForm) {
      this.filterForm.addEventListener('change', this.onFilterChange.bind(this));
      this.filterForm.addEventListener('input', this.debounce(this.onFilterChange.bind(this), 500));
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onFilterChange(event) {
    const formData = new FormData(this.filterForm);
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  closeMobileFilters() {
    const sidebar = document.querySelector('#CollectionSidebar');
    const backdrop = document.querySelector('#CollectionSidebarBackdrop');
    if (sidebar) sidebar.classList.remove('active');
    if (backdrop) backdrop.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  openMobileFilters() {
    const sidebar = document.querySelector('#CollectionSidebar');
    const backdrop = document.querySelector('#CollectionSidebarBackdrop');
    if (sidebar) sidebar.classList.add('active');
    if (backdrop) backdrop.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    this.updateURL(url);
    this.setLoading(true);

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderSections(html);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  renderSections(html) {
    const selectors = ['#product-grid', '#ProductCount', '.active-facets', '.pagination'];
    selectors.forEach(selector => {
      const sourceElement = html.querySelector(selector);
      const destinationElement = document.querySelector(selector);
      if (sourceElement && destinationElement) {
        destinationElement.innerHTML = sourceElement.innerHTML;
      } else if (destinationElement) {
        destinationElement.innerHTML = ''; // Clear if no source
      }
    });
    
    // Auto-close on mobile after apply
    if (window.innerWidth < 990) {
      this.closeMobileFilters();
    }
  }

  updateURL(url) {
    window.history.pushState({ path: url }, '', url);
  }

  setLoading(isLoading) {
    const grid = document.querySelector('#product-grid');
    if (isLoading) {
      grid.classList.add('loading');
    } else {
      grid.classList.remove('loading');
    }
  }

  initFacets() {
    this.querySelectorAll('.facets__summary').forEach(summary => {
      summary.addEventListener('click', (event) => {
        const disclosure = event.currentTarget.closest('.facets__disclosure');
        const isOpened = disclosure.classList.contains('is-open');
        
        // Close all others
        this.querySelectorAll('.facets__disclosure').forEach(d => d.classList.remove('is-open'));
        
        if (!isOpened) {
          disclosure.classList.add('is-open');
        }
        event.stopPropagation();
      });
    });

    document.addEventListener('click', () => {
      this.querySelectorAll('.facets__disclosure').forEach(d => d.classList.remove('is-open'));
    });

    this.querySelectorAll('.facets__display').forEach(display => {
      display.addEventListener('click', (e) => e.stopPropagation());
    });
  }

  initRangeSliders() {
    const rangeSlider = this.querySelector('.range-slider');
    if (!rangeSlider) return;

    const minInput = this.querySelector('.range-slider__min');
    const maxInput = this.querySelector('.range-slider__max');
    const minPrice = this.querySelector('input[id*="GTE"]');
    const maxPrice = this.querySelector('input[id*="LTE"]');
    const track = this.querySelector('.range-slider__track');

    const updateTrack = () => {
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const percentMin = (min / minInput.max) * 100;
      const percentMax = (max / maxInput.max) * 100;
      track.style.background = `linear-gradient(to right, #E1E0E7 ${percentMin}%, var(--hero-highlight-color) ${percentMin}%, var(--hero-highlight-color) ${percentMax}%, #E1E0E7 ${percentMax}%)`;
    };

    const handleInput = (isMin) => {
      if (parseFloat(minInput.value) >= parseFloat(maxInput.value)) {
        if (isMin) minInput.value = maxInput.value;
        else maxInput.value = minInput.value;
      }
      minPrice.value = minInput.value;
      maxPrice.value = maxInput.value;
      updateTrack();
    };

    minInput.addEventListener('input', () => handleInput(true));
    maxInput.addEventListener('input', () => handleInput(false));

    // Also update when number inputs change
    [minPrice, maxPrice].forEach(input => {
      input.addEventListener('change', () => {
        minInput.value = minPrice.value || 0;
        maxInput.value = maxPrice.value || maxInput.max;
        updateTrack();
      });
    });

    // Trigger form submit on change (after slider interaction ends)
    [minInput, maxInput].forEach(input => {
      input.addEventListener('change', () => {
        this.onFormSubmit();
      });
    });

    updateTrack();
  }

  connectedCallback() {
    this.initFacets();
    this.initRangeSliders();
    this.initMobileFilters();
  }

  initMobileFilters() {
    const trigger = document.querySelector('.js-mobile-facets-trigger');
    const closeBtn = this.querySelector('.js-mobile-facets-close');
    const backdrop = document.querySelector('#CollectionSidebarBackdrop');

    if (trigger) {
      trigger.addEventListener('click', () => this.openMobileFilters());
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeMobileFilters());
    }

    if (backdrop) {
      backdrop.addEventListener('click', () => this.closeMobileFilters());
    }
  }
}

customElements.define('collection-filters', CollectionFilters);

// Handle browser back/forward buttons
window.addEventListener('popstate', () => {
  window.location.reload();
});

// Update sorting in toolbar to use AJAX too
document.addEventListener('DOMContentLoaded', () => {
  const sortByToolbar = document.querySelector('#SortBy-Toolbar');
  if (sortByToolbar) {
    sortByToolbar.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      const filterComponent = document.querySelector('collection-filters');
      if (filterComponent) {
        filterComponent.renderPage(url.searchParams.toString());
      } else {
        window.location.href = url.href;
      }
    });
  }
});
